module.exports = __webpack_public_path__ + "img/cross.93ed196b.svg";